// extracted by mini-css-extract-plugin
module.exports = {"Home":"Home_Home__2cTiY","Home__Header":"Home_Home__Header__3Kbxd","Home__Description":"Home_Home__Description__UWBev"};